import React, { useEffect, useState } from "react";
import { ColumnDropdown } from "../../../../../../../components/Dropdownn";
import { DateBox, LoadPanel, NumberBox, ScrollView } from "devextreme-react";
import { GoTOObligationFunction } from "../../../GoTOObligationFunction";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { DataGrid, Column } from "devextreme-react/data-grid";
import axios from "axios";
import { handleGetLocal, logout } from "../../../../../../../services/auth-service";
import { getDateBoxFormat } from "../../../../../../Dateapi/dateFormatter";
import { useScreenPermission } from "../../../../../../../hooks/useScreenPermission";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset, disabled }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
        disabled={disabled}
      />
    </>
  );
};

const AddEditEMPeriodPopup = ({
  addEditEMPeriodPopup,
  setAddEditEMPeriodPopup,
  typeTab,
  rowLevelData,
  gObligationID,
  emTypeDropdownData,
  frequencyDropdownData,
  setLoading,
  setToastConfig,
  toastConfig,
  refreshApi,
  endReasonDropdownData,
  vEmPeriodData,
  gotooblogationValue,
  paymentTypeDropdownData,
  obligationDropdownData,
  equipmentTypeDropdownData,
  isAccrual,
  isAccrued,
  refreshObligationHeader,
  height,
}) => {
  const [fields, setFields] = useState({
    primaryEmType: { name: "", id: "" },
    periodEmStart: "",
    periodEmEnd: "",
    obligationEmType: { name: "", id: "" },
    obligation: { name: "", id: "" },
    obligationRateStartDate: "",
    obligationRateEndDate: "",
    obligationFrequency: { name: "", id: "" },
    rate: "0",
    paymentTypeDropdown: { name: "", id: "" },
    equipmentTypeDropdown: { name: "", id: "" },
    endReason: { name: "", id: "" },
  });

  const [days, setDays] = useState(0);

  const apiClass = new GoTOObligationFunction();
  const navigate = useNavigate();
  const [emTypeErrorValidation, setEmTypeErrorValidation] = useState("");
  const [obligationFrequencyErrorValidation, setObligationFrequencyErrorValidation] = useState("");
  const [rateErrorValidation, setRateErrorValidation] = useState("");
  const [paymentTypeErrorValidation, setPaymentTypeErrorValidation] = useState("");
  const [equipmentTypeErrorValidation, setEquipmentTypeErrorValidation] = useState("");
  const [startDateErrorValidation, setstartDateErrorValidation] = useState("");
  const [obligationErrorValidation, setObligationErrorValidation] = useState("");
  // const [endReasonErrorValidation,setEndReasonErrorValidation] = useState("");
  const SCREEN_NAME = "EM5";
  const { permission, permissionLoading } = useScreenPermission(SCREEN_NAME, navigate);
  const [lockDate, setLockDate] = useState(null);
  const [isFinancialPeriodClosed, setIsFinancialPeriodClosed] = useState(false);
  const [financialCloseMessage, setFinancialCloseMessage] = useState("");
  const [financialPeriodChecking, setFinancialPeriodChecking] = useState(false);

  // ---- Lock helpers & derived state ----
  const hasLock = !!lockDate;
  const dateOnly = (v) => (v ? new Date(new Date(v).setHours(0, 0, 0, 0)) : null);

  const startDateVal = fields.obligationRateStartDate ? dateOnly(fields.obligationRateStartDate) : null;

  const endDateVal = fields.obligationRateEndDate ? dateOnly(fields.obligationRateEndDate) : null;

  const isStartBeforeLock = hasLock && startDateVal && startDateVal < lockDate;

  // Start Date (Rate Start Date)
  const canEditStartDate = !hasLock || !startDateVal || (startDateVal && startDateVal >= lockDate);

  // End Date rules:
  // - Can edit only if it's currently null AND start date is not before lock
  // - Any entered value must be >= lock
  const canEditEndDate = !hasLock || (!isStartBeforeLock && !endDateVal);

  // Rate:
  // - Cannot edit if start date < lock date
  const canEditRate = !hasLock || !isStartBeforeLock;

  // Simple guard to compare dates during save/changes
  const isBefore = (d1, d2) => d1 && d2 && new Date(d1) < new Date(d2);

  const { dockerValue } = useSelector((store) => store.participateNotes);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "rate") {
      setRateErrorValidation("");
    }
  };

  useEffect(() => {
    if (!addEditEMPeriodPopup || typeTab === "Add") {
      setIsFinancialPeriodClosed(false);
      setFinancialCloseMessage("");
      return;
    }

    const financialDate = rowLevelData?.["Rate Start"] || rowLevelData?.dStart;

    if (!financialDate) {
      setIsFinancialPeriodClosed(false);
      setFinancialCloseMessage("");
      return;
    }

    const pathname = handleGetLocal("pathURL");

    setFinancialPeriodChecking(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/Financial/financial-period-status`, {
        params: {
          financialDate: financialDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
      })
      .then((response) => {
        const result = response?.data;

        if (result?.isSuccess && result?.data) {
          const closed = result.data.isClosed;

          setIsFinancialPeriodClosed(closed);

          if (closed) {
            setFinancialCloseMessage(
              `The financial period for ${result.data.financialMonth} is closed. ` +
                `The close date was ${new Date(
                  result.data.closeDate,
                ).toLocaleDateString()}. This monitoring period cannot be edited.`,
            );
          } else {
            setFinancialCloseMessage("");
          }
        }
      })
      .catch((error) => {
        console.log("financial-period-status error", error);

        setIsFinancialPeriodClosed(false);
        setFinancialCloseMessage("");

        if (error?.response?.status === 401) {
          logout();
        }
      })
      .finally(() => {
        setFinancialPeriodChecking(false);
      });
  }, [addEditEMPeriodPopup, typeTab, rowLevelData]);

  useEffect(() => {
    const toLocalDateOnly = (yyyyMmDd) => {
      if (!yyyyMmDd) return null;
      const [y, m, d] = yyyyMmDd.split("-").map(Number);
      const dt = new Date(y, m - 1, d);
      dt.setHours(0, 0, 0, 0);
      return dt;
    };
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/Account/getCompanyOption?Name=Accounting Period Lock Date`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${handleGetLocal("pathURL")}`,
        },
      })
      .then((res) => {
        if (res?.data?.data) {
          setLockDate(toLocalDateOnly(res.data.data));
        }
      })
      .catch((err) => {
        if (!err?.response) {
          navigate(`/error/500`);
        } else if (err?.response?.status === 401) {
          logout();
        } else {
          console.error("Error fetching lock date", err);
        }
      });
  }, []);

  useEffect(() => {
    setEmTypeErrorValidation("");
    setObligationFrequencyErrorValidation("");
    setRateErrorValidation("");
    setPaymentTypeErrorValidation("");
    setstartDateErrorValidation("");
    setObligationErrorValidation("");
    setEquipmentTypeErrorValidation("");
    // setEndReasonErrorValidation("");
    if (typeTab === "Add") {
      const findObligationkey = obligationDropdownData?.find(
        (item) => item?.id?.toLowerCase() === gObligationID && item?.type === "Accrual",
      );
      const defaultFrequency = frequencyDropdownData.find((item) => {
        if (item.name === "Daily") return true;
      });
      const defaultPaymentType = paymentTypeDropdownData.find((item) => {
        if (item.name === "Offender") return true;
      });
      const defaultEndReason = endReasonDropdownData.find((item) => item.name === "Death");

      console.log("endReasonDropdownData for default", endReasonDropdownData);
      setFields({
        primaryEmType: { name: "", id: "" },
        periodEmStart: "",
        periodEmEnd: "",
        obligationEmType: { name: "", id: "" },
        obligation: {
          name: findObligationkey?.name,
          id: findObligationkey?.id,
        },
        obligationRateStartDate: "",
        obligationRateEndDate: "",
        obligationFrequency: defaultFrequency || { name: "", id: "" },
        rate: "0",
        paymentTypeDropdown: defaultPaymentType || { name: "", id: "" },
        equipmentTypeDropdown: { name: "", id: "" },
        endReason: defaultEndReason || { name: "", id: "" },
      });
    } else {
      const equipmentType = equipmentTypeDropdownData.find(
        (x) => x.id?.toLowerCase() === rowLevelData?.gEquipmentTypeId?.toLowerCase(),
      );
      const selectedEndReason = (endReasonDropdownData || []).find(
        (x) => x.id?.toLowerCase() === rowLevelData?.gEndReasonId?.toLowerCase(),
      );
      console.log("row level data", rowLevelData);

      setFields((prev) => ({
        ...prev,
        primaryEmType: {
          name: rowLevelData?.[`Monitoring Type`],
          id: rowLevelData?.gEmTypeId,
        },
        periodEmStart: rowLevelData?.dStart,
        periodEmEnd: rowLevelData?.dEnd,
        obligationEmType: {
          name: rowLevelData?.[`Monitoring Type`],
          id: rowLevelData.gEmTypeId,
        },
        obligationRateStartDate: rowLevelData?.[`Rate Start`],
        obligationRateEndDate: rowLevelData?.[`Rate End`],
        obligationFrequency: {
          name: rowLevelData.Frequency,
          id: rowLevelData.gRateFrequencyId,
        },
        rate: rowLevelData.Amount,
        paymentTypeDropdown: {
          name: rowLevelData?.sPaymentTypeName,
          id: rowLevelData?.sPaymentTypeId,
        },
        obligation: {
          name: rowLevelData?.Obligation,
          id: rowLevelData?.gObligationId,
        },
        equipmentTypeDropdown: { ...equipmentType },
        endReason: selectedEndReason || { name: "", id: "" },
      }));
    }
  }, [
    addEditEMPeriodPopup,
    obligationDropdownData,
    frequencyDropdownData,
    paymentTypeDropdownData,
    endReasonDropdownData,
  ]);

  const getDocketId = () => {
    if (typeTab === "Add") {
      if (gotooblogationValue && gotooblogationValue.userinfo.gDocketId) {
        return gotooblogationValue.userinfo.gDocketId;
      } else if (dockerValue && dockerValue.getTopDynamicDocketid) {
        return dockerValue.getTopDynamicDocketid;
      } else if (gotooblogationValue && gotooblogationValue.userinfo.getTopDynamicDocketid) {
        return gotooblogationValue.userinfo.getTopDynamicDocketid;
      }
    } else {
      if (rowLevelData && rowLevelData.gDocketId) {
        return rowLevelData.gDocketId;
      }
    }
    return null;
  };
  console.log("Selected End Reason Object:", fields.endReason);
  console.log("Selected End Reason ID:", fields.endReason.id);

  const apiPayload = {
    GPeriodObligationId: typeTab === "Add" ? "00000000-0000-0000-0000-000000000000" : rowLevelData?.gPeriodObligationId,
    GEmPeriodId: typeTab === "Add" ? rowLevelData?.gEmPeriodId : rowLevelData?.gPeriodId,
    GDocketId: getDocketId(),
    GEMTypeId: fields?.obligationEmType.id || "4461be95-d913-4f07-9b40-4793cfc15075", //mandatory filed
    GObligationId: typeTab === "Add" ? gObligationID : fields.obligation.id,
    FRate: fields?.rate || "0", //mandatory filed
    GRateFrequencyId: fields.obligationFrequency.id, //mandatory filed
    GEntryUserId: localStorage.getItem("gUserId"),
    DStart: fields.periodEmStart,
    DEnd: fields.periodEmEnd,
    DRateStart: fields.obligationRateStartDate,
    DRateEnd: fields.obligationRateEndDate,
    GEmPaymentTypeId: fields.paymentTypeDropdown.id,
    GEmEquipmentTypeId: fields.equipmentTypeDropdown.id,
    GEndReasonId: fields.endReason.id,
  };
  console.log("API Payload:", apiPayload);
  const handleSave = () => {
    if (typeTab === "Add" && !permission.add) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        message: "You do not have Add access for EM.5.",
        type: "error",
      });
      return;
    }

    if (typeTab !== "Add" && !permission.edit) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        message: "You do not have Edit access for EM.5.",
        type: "error",
      });
      return;
    }
    let isValid = true;
    // if (fields.obligationEmType.id === "") {
    //   isValid = false;
    //   setEmTypeErrorValidation("Please Select EM Type");
    // }
    if (fields.obligation.id === "" || !fields.obligation.id) {
      isValid = false;
      setObligationErrorValidation("Please Select Obligation");
    }
    if (fields.obligationFrequency.id === "") {
      isValid = false;
      setObligationFrequencyErrorValidation("Please Select Frequency");
    }
    if (fields.paymentTypeDropdown.id === "") {
      isValid = false;
      setPaymentTypeErrorValidation("Please Select Payment Type");
    }
    if (fields.rate === "") {
      isValid = false;
      setRateErrorValidation("Please Enter Valid Amount");
    }
    // if (fields.periodEmStart === "" || fields.obligationRateStartDate === "")
    if (fields.obligationRateStartDate === "") {
      isValid = false;
      setstartDateErrorValidation("Please Enter Start Date");
    }
    // if (fields.equipmentTypeDropdown.id === "" && isAccrual) {
    if (fields.equipmentTypeDropdown.id === "" && isAccrued) {
      isValid = false;
      setEquipmentTypeErrorValidation("Please Select Equipment Type");
    }

    // if(fields.endReason.id === ""){
    //   isValid = false;
    //   setEndReasonErrorValidation("Please Select End Reason")
    // }

    if (isValid) {
      if (getDocketId() === null) {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          message: "Something went wrong with gDocketId",
          type: "error",
        });
        setTimeout(() => {
          setToastConfig({
            ...toastConfig,
            isVisible: false,
          });
        }, 1900);
        return;
      }
      console.log("API Payload:", apiPayload);

      apiClass.addEditPeriodObligation(
        navigate,
        setLoading,
        setToastConfig,
        toastConfig,
        apiPayload,
        typeTab,
        setAddEditEMPeriodPopup,
        refreshApi,
        refreshObligationHeader,
      );
    }
  };
  // console.log("End Reason DropDown Data", endReasonDropdownData);
  // console.log("Selected Field", fields.endReason);
  return (
    <>
      <LoadPanel shadingColor="true" visible={permissionLoading} delay={10} />
      <div className="add-edit-emperiod-popup" style={{ height: height }}>
        <div className="popup_header">
          <div className="popup_header_title">
            <div class="popup_header_title_data">
              <p>Monitoring Periods</p>
            </div>
            <p class="popup_header_title_para">EM.5</p>
          </div>
          <svg
            onClick={() => {
              setAddEditEMPeriodPopup(false);
            }}
            style={{
              cursor: "pointer",
            }}
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
              fill="white"
            />
          </svg>
        </div>
        {typeTab !== "Add" && isFinancialPeriodClosed && (
          <div className="financial_close_warning">{financialCloseMessage}</div>
        )}
        {!permission.view ? (
          <div style={{ padding: "20px", fontWeight: 600 }}>You do not have View access for EM.5.</div>
        ) : (
          <div className="add-edit-emperiod-container">
            <p className="container-fields-heading">EM Obligation</p>
            <div>
              <p style={{ paddingBottom: "10px" }}>EM Period</p>
              <DataGrid
                dataSource={vEmPeriodData}
                showBorders={true}
                columnAutoWidth={true}
                rowAlternationEnabled={true}
                hoverStateEnabled={true}
                height="auto"
              >
                <Column dataField="sEmType" caption="EM Type" />
                <Column dataField="dStart" caption="Start Date" dataType="date" />
                <Column dataField="dEnd" caption="End Date" dataType="date" />
                <Column dataField="iDuration" caption="Duration" />
                <Column dataField="sEndReason" caption="End Reason" />
              </DataGrid>
            </div>
            <div className="edit_container_first">
              <div className="edit_content_flex edit_content_space">
                <p className="">
                  Obligation <span className="marks_mandatary">*</span>
                </p>
                <DropDown
                  setfields={setFields}
                  fields={fields}
                  fieldNmae={"obligation"}
                  // dropDownData={obligationDropdownData.filter((obligation) => obligation?.type === "Accrual")}
                  dropDownData={obligationDropdownData.filter((obligation) => obligation?.id === gObligationID)}
                  // disabled={typeTab === "Add"}
                  reset={setObligationErrorValidation}
                  disabled={typeTab !== "Add" && isFinancialPeriodClosed}
                />
                {obligationErrorValidation && (
                  <p className="error_validation" style={{ position: "absolute", top: "478px" }}>
                    {obligationErrorValidation}
                  </p>
                )}
              </div>
              <div className="edit_content_flex edit_content_space">
                <p className="">
                  Payment Type <span className="marks_mandatary">*</span>
                </p>
                <DropDown
                  setfields={setFields}
                  fields={fields}
                  fieldNmae={"paymentTypeDropdown"}
                  dropDownData={paymentTypeDropdownData}
                  reset={setPaymentTypeErrorValidation}
                  disabled={typeTab !== "Add" && isFinancialPeriodClosed}
                />
                {paymentTypeErrorValidation && (
                  <p className="error_validation" style={{ position: "absolute", top: "389px" }}>
                    {paymentTypeErrorValidation}
                  </p>
                )}
              </div>
            </div>
            <div className="edit_container_first">
              <div className="edit_content_flex edit_content_space">
                <p>
                  Rate Start Date <span className="marks_mandatary">*</span>
                </p>
                {startDateErrorValidation && <p className="error_validation">{startDateErrorValidation}</p>}
                <DateBox
                  displayFormat={getDateBoxFormat()}
                  useMaskBehavior={true}
                  value={fields.obligationRateStartDate || null}
                  min={hasLock ? lockDate : undefined}
                  disabled={!canEditStartDate || (typeTab !== "Add" && isFinancialPeriodClosed)}
                  isValid={true}
                  onValueChange={(e) => {
                    // Enforce >= Lock Date if lock present
                    // if (hasLock && e && new Date(e) < lockDate) {
                    //   setstartDateErrorValidation(`Start Date must be on/after ${lockDate.toISOString().slice(0, 10)}`);
                    //   return;
                    // }
                    setFields((prev) => ({
                      ...prev,
                      obligationRateStartDate: e || null,
                    }));
                    setstartDateErrorValidation("");
                  }}
                />
                {/* {hasLock && isStartBeforeLock && (
                <p className="info_text">
                  Locked: Start Date is before the Accounting Period Lock Date and cannot be changed.
                </p>
              )} */}
              </div>
              <div style={{ display: "flex" }}>
                <NumberBox
                  width={"15%"}
                  onKeyDown={(e) => {
                    const { event } = e;
                    const str = event.key || String.fromCharCode(event.which);
                    if (/^[.,e]$/.test(str)) {
                      event.preventDefault();
                    }
                  }}
                  defaultValue={0}
                  onValueChange={(e) => {
                    setDays(e);
                  }}
                  isValid={true}
                  value={days}
                />
                <button
                  onClick={() => {
                    if (!fields || !fields.obligationRateStartDate || !days) {
                      return;
                    }

                    const startDate = new Date(fields.obligationRateStartDate);
                    const daysToAdd = parseInt(days, 10);

                    if (isNaN(daysToAdd)) {
                      return;
                    }

                    const endDate = new Date(startDate);
                    endDate.setDate(startDate.getDate() + daysToAdd);
                    const formattedEndDate = endDate.toISOString().split("T")[0];

                    setFields({
                      ...fields,
                      obligationRateEndDate: formattedEndDate,
                    });
                  }}
                  style={{ width: "auto", marginLeft: "10px" }}
                  disabled={typeTab !== "Add" && isFinancialPeriodClosed}
                >
                  Add Days
                </button>
                <button
                  onClick={() => {
                    if (!fields || !fields.obligationRateStartDate || !days) {
                      return;
                    }

                    const startDate = new Date(fields.obligationRateStartDate);
                    const monthsToAdd = parseInt(days, 10);

                    if (isNaN(monthsToAdd)) {
                      return;
                    }

                    const endDate = new Date(startDate);
                    endDate.setMonth(startDate.getMonth() + monthsToAdd);
                    const formattedEndDate = endDate.toISOString().split("T")[0];

                    setFields({
                      ...fields,
                      obligationRateEndDate: formattedEndDate,
                    });
                  }}
                  style={{ width: "auto", marginLeft: "10px" }}
                  disabled={typeTab !== "Add" && isFinancialPeriodClosed}
                >
                  Add Months
                </button>
              </div>
            </div>
            <div className="edit_container_first">
              <div className="edit_content_flex edit_content_space">
                <p className="">Rate End Date</p>
                <DateBox
                  displayFormat={getDateBoxFormat()}
                  value={fields.obligationRateEndDate || null}
                  min={hasLock ? lockDate : undefined}
                  disabled={!canEditEndDate}
                  isValid={true}
                  onValueChange={(e) => {
                    if (!e) {
                      setFields((prev) => ({ ...prev, obligationRateEndDate: null }));
                      return;
                    }
                    if (hasLock && new Date(e) < lockDate) {
                      setstartDateErrorValidation(`End Date must be on/after ${lockDate.toISOString().slice(0, 10)}`);
                      return;
                    }
                    setFields((prev) => ({
                      ...prev,
                      obligationRateEndDate: e,
                    }));
                    setstartDateErrorValidation("");
                  }}
                />
              </div>
              {/* <div className="edit_content_flex edit_content_space">
              <p>
                End Reason<span></span>
              </p>
                <DropDown
                setfields={setFields}
                fields={fields}
                fieldNmae={"End Reason"}
                />
                
            </div > */}

              <div className="edit_content_flex edit_content_space">
                <p className="">End Reason</p>
                <DropDown
                  setfields={setFields}
                  fields={fields}
                  fieldNmae={"endReason"}
                  dropDownData={endReasonDropdownData}
                  // reset={setEndReasonErrorValidation}
                />
                {/* {
              endReasonErrorValidation && (
                <p className="error_validation" style={{ position: "absolute", top: "361px" }} >
                  {endReasonErrorValidation}
                </p>
              )
             } */}
              </div>
            </div>

            <div className="edit_container_first">
              <div className="edit_content_flex">
                <p className="">
                  Rate <span className="marks_mandatary">*</span>
                </p>
                <input
                  id="rate"
                  name="rate"
                  type="number"
                  placeholder="Enter Rate"
                  className="edit_container_input"
                  value={fields?.rate}
                  onChange={handleInputChange}
                  style={{ width: "310px" }}
                  disabled={!canEditRate || (typeTab !== "Add" && isFinancialPeriodClosed)}
                />
                {rateErrorValidation && (
                  <p className="error_validation" style={{ position: "absolute", top: "655px" }}>
                    {rateErrorValidation}
                  </p>
                )}
              </div>
              <div className="edit_content_flex edit_content_space">
                <p className="">
                  Frequency <span className="marks_mandatary">*</span>
                </p>
                <DropDown
                  setfields={setFields}
                  fields={fields}
                  fieldNmae={"obligationFrequency"}
                  dropDownData={frequencyDropdownData}
                  reset={setObligationFrequencyErrorValidation}
                  disabled={!canEditRate || (typeTab !== "Add" && isFinancialPeriodClosed)}
                />
                {obligationFrequencyErrorValidation && (
                  <p className="error_validation" style={{ position: "absolute", top: "567px" }}>
                    {obligationFrequencyErrorValidation}
                  </p>
                )}
              </div>
            </div>

            <div className="edit_container_first">
              <div className="edit_content_flex edit_content_space">
                <p className="">
                  Equipment Type <span className="marks_mandatary">*</span>
                </p>
                {equipmentTypeErrorValidation && <p className="error_validation">{equipmentTypeErrorValidation}</p>}
                <DropDown
                  setfields={setFields}
                  fields={fields}
                  fieldNmae={"equipmentTypeDropdown"}
                  dropDownData={equipmentTypeDropdownData}
                  reset={setEquipmentTypeErrorValidation}
                  disabled={typeTab !== "Add" && isFinancialPeriodClosed}
                />
              </div>
            </div>

            <div className="popup_buttons">
              <button
                className="btn primary_btn"
                disabled={typeTab === "Add" ? !permission.add : !permission.edit}
                style={{
                  opacity: typeTab === "Add" ? (permission.add ? 1 : 0.6) : permission.edit ? 1 : 0.6,
                  cursor:
                    typeTab === "Add"
                      ? permission.add
                        ? "pointer"
                        : "not-allowed"
                      : permission.edit
                        ? "pointer"
                        : "not-allowed",
                }}
                onClick={handleSave}
              >
                Save
              </button>
              <button
                className="btn"
                onClick={() => {
                  setAddEditEMPeriodPopup(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AddEditEMPeriodPopup;
